import React, { Component } from 'react';
import { compose } from 'redux';

import withCookieHeaderHeight from './withCookieHeaderHeight';

import './withStickyBehaviorSearch.scss';

const withStickyBehaviorSearch = (StickyComponent) =>
    class WithStickyBehaviorSearchWrapper extends Component {
        render() {
            return (
                <div
                    className="feed-search-page__header feed-search-page__header--is-browse"
                    style={{
                        top: this.props.cookieHeaderHeight,
                    }}
                >
                    <StickyComponent {...this.props}>
                        {this.props.children}
                    </StickyComponent>
                </div>
            );
        }
    };

export default compose(withCookieHeaderHeight, withStickyBehaviorSearch);
